import React, { useEffect, useRef, useState, useContext } from "react";
import Button from "../button/Button";
import { ClipLoader } from "react-spinners";
import { CurrentUserContext } from "../../../App";
import { CloudArrowUpIcon } from "@heroicons/react/24/outline";
import { ImBin } from "react-icons/im";

function UploadImage({ type, value, setValue, api, title, limit }) {
  const { setIsMessage } = useContext(CurrentUserContext);

  const inputFileRef = useRef(null);
  const [loading, setLoading] = useState(false);

  let type_list;
  if (type === "image") {
    type_list = "image/png, image/jpg, image/jpeg";
  } else if (type === "file") {
    type_list = "application/pdf";
  } else {
    type_list = type;
  }

  // ฟังก์ชันสำหรับส่ง API (แยกออกมาให้เรียกใช้ง่ายขึ้น)
  const uploadFile = async (fileObj) => {
    if (!fileObj) return;
    
    setLoading(true);
    try {
      let formData = { data: fileObj };
      let res = await api(formData);

      if (res["data"]["code"] === 200) {
        setIsMessage({ type: 'success', data: 'อัปโหลดสำเร็จ' });
        setValue(res["data"]["url"]); // เก็บ URL ที่ได้จาก Server
      } else {
        setIsMessage({ type: 'warning', data: res?.data?.message_th || "อัปโหลดไม่สำเร็จ" });
      }
    } catch (error) {
      setIsMessage({ type: 'error', data: "เกิดข้อผิดพลาดในการอัปโหลด" });
    } finally {
      setLoading(false);
      if (inputFileRef.current) inputFileRef.current.value = ""; // Reset input ให้เลือกไฟล์เดิมซ้ำได้
    }
  };

  const inputFileChange = (event) => {
    const fileObj = event.target.files[0];
    if (!fileObj) return;

    // ตรวจสอบขนาดไฟล์
    if (limit) {
      const fileSizeInMB = fileObj.size / (1024 * 1024);
      if (fileSizeInMB > limit) {
        setIsMessage({ type: 'warning', data: `ไฟล์มีขนาดใหญ่เกินไป (จำกัด ${limit}MB)` });
        return;
      }
    }

    // เมื่อผ่านเงื่อนไข ให้สั่งอัปโหลดทันที
    uploadFile(fileObj);
  };

  return (
    <div className="flex flex-col justify-center items-center gap-4">
      {/* ส่วนแสดงผลไฟล์ที่อัปโหลดแล้ว */}
      {value && (
        <div className="relative border p-2 rounded-lg bg-white shadow-sm flex flex-col items-center gap-2">
          {type === "image" ? (
            <img
              src={value}
              className="w-[200px] h-[120px] object-cover rounded-md"
              alt="Preview"
            />
          ) : (
            <div className="bg-gray-50 p-3 rounded border text-[#06A7AD] text-sm">
              ไฟล์อัปโหลดสำเร็จแล้ว
            </div>
          )}
          
          <button
            onClick={() => setValue("")} // ลบค่า URL เพื่ออัปโหลดใหม่
            className="p-2 rounded-md bg-red-500 text-white hover:bg-red-600 transition-colors"
          >
            <ImBin />
          </button>
        </div>
      )}

      {/* ปุ่มกดอัปโหลด (จะซ่อนไว้ถ้ามีไฟล์แล้ว หรืออยากให้ทับกันก็ได้) */}
      {!value && (
        <div className="flex flex-col items-center">
          <input
            accept={type_list}
            type="file"
            ref={inputFileRef}
            onChange={inputFileChange}
            style={{ display: "none" }}
          />
          
          <Button
            onClick={() => !loading && inputFileRef.current.click()}
            disabled={loading}
            style={{
              gridGap: 10,
              width: "300px",
              height: "125px",
              background: "#FFFFFF",
              border: "1px dashed #AEE7E8",
              borderRadius: "14px",
              color: "#06A7AD",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
              cursor: loading ? "not-allowed" : "pointer"
            }}
          >
            {loading ? (
              <ClipLoader size={30} color="#06A7AD" />
            ) : (
              <>
                <CloudArrowUpIcon className="w-[45px] h-[31px]" />
                <div className="text-sm">คลิกเพื่ออัปโหลดไฟล์</div>
              </>
            )}
          </Button>

          <div className="text-[#06A7AD] text-[12px] mt-2">{title ?? ""}</div>
        </div>
      )}
    </div>
  );
}

export default UploadImage;